import { render, staticRenderFns } from "./families-overview.vue?vue&type=template&id=55ea1546&"
import script from "./families-overview.vue?vue&type=script&lang=js&"
export * from "./families-overview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports